import { Helmet } from "react-helmet-async";

type SEOProps = {
  title?: string;
  description?: string;
  canonical?: string;
  ogImage?: string;
};

const SITE = "APA Automotive";
const BASE = "https://apaauto.ca";
const DEFAULT_IMAGE = `${BASE}/images/Hero.png`;

export function SEO({
  title,
  description,
  canonical,
  ogImage = DEFAULT_IMAGE,
}: SEOProps) {
  const fullTitle = title ? `${title} — ${SITE}` : `${SITE} — Full-Service Auto Repair & Tires in Milton, ON`;
  const canonicalUrl = canonical ? `${BASE}${canonical}` : undefined;

  return (
    <Helmet>
      {title && <title>{fullTitle}</title>}
      {description && <meta name="description" content={description} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      {title && <meta property="og:title" content={fullTitle} />}
      {description && <meta property="og:description" content={description} />}
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      <meta property="og:image" content={ogImage} />
      {title && <meta name="twitter:title" content={fullTitle} />}
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
